import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { EuiLayoutModule } from '@eui/components/layout';
import { EuiBadgeModule } from '@eui/components/eui-badge';
import { EuiIconToggleModule } from '@eui/components/eui-icon-toggle';
import { EuiLabelModule } from '@eui/components/eui-label';
import { EuiIconModule } from '@eui/components/eui-icon';
import { EuiAutocompleteModule } from '@eui/components/eui-autocomplete';
import { EuiButtonModule } from '@eui/components/eui-button';
import { EuiButtonGroupModule } from '@eui/components/eui-button-group';
import { EuiCardModule } from '@eui/components/eui-card';
import { EuiChipModule } from '@eui/components/eui-chip';
import { EuiChipListModule } from '@eui/components/eui-chip-list';
import { EuiDashboardButtonModule } from '@eui/components/eui-dashboard-button';
import { EuiDashboardCardModule } from '@eui/components/eui-dashboard-card';
import { EuiDateRangeSelectorModule } from '@eui/components/eui-date-range-selector';
import { EuiDialogModule } from '@eui/components/eui-dialog';
import { EuiDropdownButtonMenuModule } from '@eui/components/eui-dropdown-button-menu';
import { EuiDropdownModule } from '@eui/components/eui-dropdown';
import { EuiMenuModule } from '@eui/components/eui-menu';
import { EuiSlideToggleModule } from '@eui/components/eui-slide-toggle';
import { EuiTabsModule } from '@eui/components/eui-tabs';
import { EuiListModule } from '@eui/components/eui-list';
import { EuiTableModule } from '@eui/components/eui-table';
import { EuiFileUploadModule } from '@eui/components/eui-file-upload';
import { EuiBlockDocumentModule } from '@eui/components/eui-block-document';
import { EuiBlockContentModule } from '@eui/components/eui-block-content';
import { EuiButtonsModule } from '@eui/components/eui-buttons';
import { EuiPickerModule } from '@eui/components/eui-picker';
import { EuiGrowlModule } from '@eui/components/eui-growl';
import { EuiAlertModule } from '@eui/components/eui-alert';
import { EuiInputNumberDirectiveModule } from '@eui/components/eui-input-number';
import { EuiInputCheckboxModule } from '@eui/components/eui-input-checkbox';
import { EuiInputRadioModule } from '@eui/components/eui-input-radio';
import { EuiInputTextModule } from '@eui/components/eui-input-text';
import { EuiPopoverModule } from '@eui/components/eui-popover';
import { EuiSelectModule } from '@eui/components/eui-select';
import { EuiTextAreaModule } from '@eui/components/eui-textarea';
import { EuiInputGroupModule } from '@eui/components/eui-input-group';
import { EuiFeedbackMessageModule } from '@eui/components/eui-feedback-message';
import { EuiTimepickerModule } from '@eui/components/eui-timepicker';
import { EuiDatepickerModule } from '@eui/components/eui-datepicker';
import { EuiDimmerModule } from '@eui/components/eui-dimmer';
import { EuiPageModule } from '@eui/components/eui-page';
import { EuiOverlayModule } from '@eui/components/eui-overlay';
import { EuiFieldsetModule } from '@eui/components/eui-fieldset';
import { EuiMessageBoxModule } from '@eui/components/eui-message-box';
import { EuiPaginatorModule } from '@eui/components/eui-paginator';
import { EuiProgressCircleModule } from '@eui/components/eui-progress-circle';
import { EuiDisableContentModule } from '@eui/components/eui-disable-content';
import { EuiWizardModule } from '@eui/components/eui-wizard';
import { EuiTimelineModule } from '@eui/components/eui-timeline';
import { EuiTimebarModule } from '@eui/components/eui-timebar';
import { EuiDiscussionThreadModule } from '@eui/components/eui-discussion-thread';
import { EuiSidebarMenuModule } from '@eui/components/eui-sidebar-menu';
import { EuiTemplateDirectiveModule, EuiTooltipDirectiveModule, EuiMaxLengthDirectiveModule, EuiSmoothScrollDirectiveModule, EuiScrollHandlerDirectiveModule, EuiHasPermissionDirectiveModule } from '@eui/components/directives';
import { EuiTruncatePipeModule } from '@eui/components/pipes';

const MODULES = [
    EuiTemplateDirectiveModule,
    EuiTooltipDirectiveModule,
    EuiInputNumberDirectiveModule,
    EuiMaxLengthDirectiveModule,
    EuiSmoothScrollDirectiveModule,
    EuiScrollHandlerDirectiveModule,
    EuiHasPermissionDirectiveModule,
    EuiLayoutModule,
    EuiPageModule,
    EuiOverlayModule,
    EuiDimmerModule,
    EuiBadgeModule,
    EuiIconModule,
    EuiLabelModule,
    EuiIconToggleModule,
    EuiAlertModule,
    EuiAutocompleteModule,
    EuiBlockDocumentModule,
    EuiBlockContentModule,
    EuiButtonModule,
    EuiButtonsModule,
    EuiCardModule,
    EuiChipModule,
    EuiChipListModule,
    EuiDashboardButtonModule,
    EuiDashboardCardModule,
    EuiDatepickerModule,
    EuiDateRangeSelectorModule,
    EuiDropdownButtonMenuModule,
    EuiDropdownModule,
    EuiDialogModule,
    EuiGrowlModule,
    EuiSlideToggleModule,
    EuiTabsModule,
    EuiMenuModule,
    EuiMessageBoxModule,
    EuiListModule,
    EuiTableModule,
    EuiFileUploadModule,
    EuiPickerModule,
    EuiPopoverModule,
    EuiFeedbackMessageModule,
    EuiTimepickerModule,
    // EuiTreeModule,
    EuiInputCheckboxModule,
    EuiSelectModule,
    EuiInputRadioModule,
    EuiInputTextModule,
    EuiTextAreaModule,
    EuiInputGroupModule,
    EuiTruncatePipeModule,
    EuiFieldsetModule,
    EuiPaginatorModule,
    EuiButtonGroupModule,
    EuiProgressCircleModule,
    EuiDisableContentModule,
    EuiWizardModule,
    EuiTimelineModule,
    EuiTimebarModule,
    EuiDiscussionThreadModule,
    EuiSidebarMenuModule,
];
class EuiAllModule {
}
/** @nocollapse */ EuiAllModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiAllModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiAllModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiAllModule, imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, EuiTemplateDirectiveModule,
        EuiTooltipDirectiveModule,
        EuiInputNumberDirectiveModule,
        EuiMaxLengthDirectiveModule,
        EuiSmoothScrollDirectiveModule,
        EuiScrollHandlerDirectiveModule,
        EuiHasPermissionDirectiveModule,
        EuiLayoutModule,
        EuiPageModule,
        EuiOverlayModule,
        EuiDimmerModule,
        EuiBadgeModule,
        EuiIconModule,
        EuiLabelModule,
        EuiIconToggleModule,
        EuiAlertModule,
        EuiAutocompleteModule,
        EuiBlockDocumentModule,
        EuiBlockContentModule,
        EuiButtonModule,
        EuiButtonsModule,
        EuiCardModule,
        EuiChipModule,
        EuiChipListModule,
        EuiDashboardButtonModule,
        EuiDashboardCardModule,
        EuiDatepickerModule,
        EuiDateRangeSelectorModule,
        EuiDropdownButtonMenuModule,
        EuiDropdownModule,
        EuiDialogModule,
        EuiGrowlModule,
        EuiSlideToggleModule,
        EuiTabsModule,
        EuiMenuModule,
        EuiMessageBoxModule,
        EuiListModule,
        EuiTableModule,
        EuiFileUploadModule,
        EuiPickerModule,
        EuiPopoverModule,
        EuiFeedbackMessageModule,
        EuiTimepickerModule,
        // EuiTreeModule,
        EuiInputCheckboxModule,
        EuiSelectModule,
        EuiInputRadioModule,
        EuiInputTextModule,
        EuiTextAreaModule,
        EuiInputGroupModule,
        EuiTruncatePipeModule,
        EuiFieldsetModule,
        EuiPaginatorModule,
        EuiButtonGroupModule,
        EuiProgressCircleModule,
        EuiDisableContentModule,
        EuiWizardModule,
        EuiTimelineModule,
        EuiTimebarModule,
        EuiDiscussionThreadModule,
        EuiSidebarMenuModule], exports: [EuiTemplateDirectiveModule,
        EuiTooltipDirectiveModule,
        EuiInputNumberDirectiveModule,
        EuiMaxLengthDirectiveModule,
        EuiSmoothScrollDirectiveModule,
        EuiScrollHandlerDirectiveModule,
        EuiHasPermissionDirectiveModule,
        EuiLayoutModule,
        EuiPageModule,
        EuiOverlayModule,
        EuiDimmerModule,
        EuiBadgeModule,
        EuiIconModule,
        EuiLabelModule,
        EuiIconToggleModule,
        EuiAlertModule,
        EuiAutocompleteModule,
        EuiBlockDocumentModule,
        EuiBlockContentModule,
        EuiButtonModule,
        EuiButtonsModule,
        EuiCardModule,
        EuiChipModule,
        EuiChipListModule,
        EuiDashboardButtonModule,
        EuiDashboardCardModule,
        EuiDatepickerModule,
        EuiDateRangeSelectorModule,
        EuiDropdownButtonMenuModule,
        EuiDropdownModule,
        EuiDialogModule,
        EuiGrowlModule,
        EuiSlideToggleModule,
        EuiTabsModule,
        EuiMenuModule,
        EuiMessageBoxModule,
        EuiListModule,
        EuiTableModule,
        EuiFileUploadModule,
        EuiPickerModule,
        EuiPopoverModule,
        EuiFeedbackMessageModule,
        EuiTimepickerModule,
        // EuiTreeModule,
        EuiInputCheckboxModule,
        EuiSelectModule,
        EuiInputRadioModule,
        EuiInputTextModule,
        EuiTextAreaModule,
        EuiInputGroupModule,
        EuiTruncatePipeModule,
        EuiFieldsetModule,
        EuiPaginatorModule,
        EuiButtonGroupModule,
        EuiProgressCircleModule,
        EuiDisableContentModule,
        EuiWizardModule,
        EuiTimelineModule,
        EuiTimebarModule,
        EuiDiscussionThreadModule,
        EuiSidebarMenuModule] });
/** @nocollapse */ EuiAllModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiAllModule, imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule, MODULES, EuiTemplateDirectiveModule,
        EuiTooltipDirectiveModule,
        EuiInputNumberDirectiveModule,
        EuiMaxLengthDirectiveModule,
        EuiSmoothScrollDirectiveModule,
        EuiScrollHandlerDirectiveModule,
        EuiHasPermissionDirectiveModule,
        EuiLayoutModule,
        EuiPageModule,
        EuiOverlayModule,
        EuiDimmerModule,
        EuiBadgeModule,
        EuiIconModule,
        EuiLabelModule,
        EuiIconToggleModule,
        EuiAlertModule,
        EuiAutocompleteModule,
        EuiBlockDocumentModule,
        EuiBlockContentModule,
        EuiButtonModule,
        EuiButtonsModule,
        EuiCardModule,
        EuiChipModule,
        EuiChipListModule,
        EuiDashboardButtonModule,
        EuiDashboardCardModule,
        EuiDatepickerModule,
        EuiDateRangeSelectorModule,
        EuiDropdownButtonMenuModule,
        EuiDropdownModule,
        EuiDialogModule,
        EuiGrowlModule,
        EuiSlideToggleModule,
        EuiTabsModule,
        EuiMenuModule,
        EuiMessageBoxModule,
        EuiListModule,
        EuiTableModule,
        EuiFileUploadModule,
        EuiPickerModule,
        EuiPopoverModule,
        EuiFeedbackMessageModule,
        EuiTimepickerModule,
        // EuiTreeModule,
        EuiInputCheckboxModule,
        EuiSelectModule,
        EuiInputRadioModule,
        EuiInputTextModule,
        EuiTextAreaModule,
        EuiInputGroupModule,
        EuiTruncatePipeModule,
        EuiFieldsetModule,
        EuiPaginatorModule,
        EuiButtonGroupModule,
        EuiProgressCircleModule,
        EuiDisableContentModule,
        EuiWizardModule,
        EuiTimelineModule,
        EuiTimebarModule,
        EuiDiscussionThreadModule,
        EuiSidebarMenuModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiAllModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
                        ...MODULES,
                    ],
                    exports: [
                        ...MODULES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiAllModule };
